// extracted by mini-css-extract-plugin
export default {"wrapper":"Users_wrapper__JjUNr","emptyList":"Users_emptyList__jP7NY","iconHistory":"Users_iconHistory__p0Hl0","icon":"Users_icon__PqaQh"};